export const GET_BUS_DETAILS_SUCCESS = "GET_BUS_DETAILS_SUCCESS";
export const GET_BUS_DETAILS_REQUEST = "GET_BUS_DETAILS_REQUEST";
export const GET_BUS_DETAILS_FAIL = "GET_BUS_DETAILS_FAIL";
export const UPDATE_BOOKING_DETAILS = "UPDATE_BOOKING_DETAILS";
